// Admin Imports
import MainDashboard from "views/admin/default";

// Auth Imports
import SignIn from "views/auth/SignIn";

// Icon Imports
import {
  MdAttachMoney,
  MdGroup,
  MdGroups,
  MdLock,
  MdNotifications,
  MdOutlineGeneratingTokens,
  MdOutlineAttachMoney,
  MdVideoFile,
  MdMusicVideo,
  MdVideoCameraFront,
} from "react-icons/md";
import FeeView from "views/admin/fee";
import AdminsView from "views/admin/manageAdmins";
import PushNotificationsView from "views/admin/pushNotifications";
import UsersByVolume from "views/admin/usersByValues";
import TokensByPurchase from "views/admin/tokensByPurchase";
import VideoTokens from "views/admin/videoTokens";
import RevenueView from "views/admin/revenue";
import { MdVideoLibrary } from "react-icons/md";
import TutorialView from "views/admin/tutorial";

const routes = [
  {
    name: "Users Dashboard",
    layout: "/admin",
    path: "default",
    icon: <MdGroup className="h-6 w-6" />,
    component: <MainDashboard />,
  },
  {
    name: "Fee Management",
    layout: "/admin",
    icon: <MdAttachMoney className="h-6 w-6" />,
    path: "fee",
    component: <FeeView />,
  },
  // {
  //   name: 'Coohort Charts',
  //   layout: '/admin',
  //   icon: <MdAutoGraph className="h-6 w-6" />,
  //   path: 'coohort',
  //   component: <CoohortView />,
  // },
  {
    name: "Manage Admins",
    layout: "/admin",
    icon: <MdGroups className="h-6 w-6" />,
    path: "manageAdmin",
    component: <AdminsView />,
  },

  {
    name: "Push notifications",
    layout: "/admin",
    icon: <MdNotifications className="h-6 w-6" />,
    path: "pushNotifications",
    component: <PushNotificationsView />,
  },
  {
    name: "Users by volume",
    layout: "/admin",
    icon: <MdGroup className="h-6 w-6" />,
    path: "usersByVolume",
    component: <UsersByVolume />,
  },
  {
    name: "Popular tokens",
    layout: "/admin",
    icon: <MdOutlineGeneratingTokens className="h-6 w-6" />,
    path: "popularTokens",
    component: <TokensByPurchase />,
  },
  {
    name: "Video tokens",
    layout: "/admin",
    icon: <MdVideoLibrary className="h-6 w-6" />,
    path: "videoTokens",
    component: <VideoTokens />,
  },
  {
    name: "Fees",
    layout: "/admin",
    icon: <MdOutlineAttachMoney className="h-6 w-6" />,
    path: "revenue",
    component: <RevenueView />,
  },
  {
    name: "Tutorial",
    layout: "/admin",
    icon: <MdVideoCameraFront className="h-6 w-6" />,
    path: "tutorial",
    component: <TutorialView />,
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
  },
];
export default routes;
